// Modules
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import _ from 'lodash';
import moment from 'moment';

import { PrimaryButton } from 'components/widgets/buttons/buttons';
import { FormCard, TableCard } from 'components/content-containers/cards';
import { PageContent } from 'components/page';
import { Table } from 'components/content-containers/tables/tables';
import EmptyPagePlaceholder from 'components/page/empty-page-placeholder';
import FlipMove from 'components/widgets/animation/flip-move';
import TimeReportForm from 'components/models/time-report/forms/time-report-form';
import TimeReportRowSimple from 'components/models/time-report/time-report-row-simple';

import { useCurrentUser } from 'hooks';
import useTicket from '../hooks/useTicket';


function TicketTime({ params }) {
  const { ticket, timeReports, updateTime, reloadTimeReports } = useTicket(params.ticketId);
  const { currentUser } = useCurrentUser();
  const [showAllTimeReports, setShowAllTimeReports] = useState(false);

  function eagerUpdate(values) {
    const report = _.find(timeReports, { id: values.id });
    const rate = values.rate ? _.find(ticket.agreement.rates, { id: values.rate }) || report.rate : null;

    updateTime(_.defaults({ rate }, values, report));
  }

  if (!ticket || _.isEmpty(ticket) || _.isEmpty(currentUser)) return null;

  const hasAgreement = _.get(ticket, 'agreement.id');
  if (!hasAgreement) return <EmptyPagePlaceholder src="svg/time-report.svg">Add an agreement to add time to this ticket!</EmptyPagePlaceholder>;

  const isArchived = ticket.status === 'Archived';
  const time = _.orderBy(timeReports, [report => moment(report.date).toDate()], ['desc']);
  const defaultRate = _.find(ticket.agreement.rates, { role: currentUser.billingRole });
  const totalTime = _.reduce(timeReports, (total, report) => total + Number(report.duration), 0);
  const maxTimeReports = 20;
  const limitTimeReports = time.length > maxTimeReports && !showAllTimeReports;
  const visibleTime = limitTimeReports ? _.take(time, maxTimeReports) : time;

  return (
    <PageContent className="bg-medium-blue-grey ticket">
      <div className="ticket-time">
        { !isArchived &&
          <FormCard>
            <TimeReportForm
              resetOnSubmit
              afterSubmit={reloadTimeReports}
              form="ticket-add-time-report"
              preventAutoFocus
              initialValues={{
                date: moment(),
                rate: ticket.timeDefaultBillable ? defaultRate.id : 0,
                createdBy: currentUser.id,
                agreement: ticket.agreement.id,
                ticket: ticket.id,
                afterHoursPremium: _.get(ticket, 'agreement.afterHoursPremium', 0)
              }}
              agreement={ticket.agreement}
              ticket={ticket}
            />
          </FormCard>
        }
        <TableCard className="time-table">
          <Table>
            <thead>
              <tr>
                <th className="collapse-width">Date</th>
                <th className="collapse-width">User</th>
                <th>Description</th>
                <th className="right-align collapse-width">Time</th>
                <th className="collapse-width"></th>
              </tr>
            </thead>
            <FlipMove typeName="tbody" enterAnimation="fade" leaveAnimation="fade">
              {_.map(visibleTime, (report) => <TimeReportRowSimple key={report.id} report={report} eagerUpdate={eagerUpdate} />)}
              { limitTimeReports &&
                <tr>
                  <td className="vertical-align-middle text-center" colSpan="5">
                    <span className="mr-3">{time.length - maxTimeReports} more time reports hidden</span>
                    <PrimaryButton onClick={() => setShowAllTimeReports(true)}>Show All</PrimaryButton>
                  </td>
                </tr>
              }
              <tr className="total-row">
                <td colSpan="3">Total Time</td>
                <td className="right-align">{totalTime.toFixed(2)}</td>
                <td></td>
              </tr>
            </FlipMove>
          </Table>
        </TableCard>
      </div>
    </PageContent>
  );
}

TicketTime.propTypes = {
  params: PropTypes.object
};

export default TicketTime;
